<template>
    <v-panel :class="theme.appFooter">
        <!-- <div v-padding.left="2" v-padding.right="2">
            <v-text>
                {{new Date().getFullYear()}} © Unirate24.ru. Проект является частью платформы «EBC SYSTEM 2.0» 
                <v-link to="https://www.unirate24.ru/litsenzionnoe-soglashenie/" target="_blank">
                    Лицензионное соглашение
                </v-link>
            </v-text>
        </div> -->
    </v-panel>
</template>
<script>
import theme from './theme';

export default {
    name: 'app-footer',
    props: {
        theme: {
            type: Object,
            default() {
                return theme;
            }
        },
        show: Function,
    },
}
</script>



// WEBPACK FOOTER //
// AppFooter.vue?227ff760